import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Brochure = () => {
  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 200px)',
        pt: 10,
        pb: 5,
        backgroundColor: '#0f2142',
      }}
    >
      <Container maxWidth="xl">
        <Typography
          variant="h4"
          component="h1"
          sx={{
            mb: 3,
            textAlign: 'center',
            color: '#fff',
            fontWeight: 600,
          }}
        >
          Dure Technologies Brochure
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: 'calc(100vh - 250px)',
            minHeight: '600px',
            border: '1px solid #ddd',
            borderRadius: 2,
            overflow: 'hidden',
            boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
            backgroundColor: '#fff',
          }}
        >
          <iframe
            src="/dure-brochure.pdf"
            width="100%"
            height="100%"
            title="Dure Technologies Brochure"
            style={{
              border: 'none',
            }}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default Brochure;


